module.exports = __webpack_public_path__ + "media/images/new_landing/logos/lush-3cdc1923857cbf0d724f60844d1b5142.png";